import useGraphDataSocket from "@shared/services/socket/useGraphDataSocket";
import React, { CSSProperties, useEffect } from "react";
import { EXCHANGES } from "@shared/common/constants";
import { DisplayCurrency, PrecisionType } from "@shared/types";
import useLiveAvgPriceChange from "@shared/common/LiveComponents/useLiveAvgPriceChange";
import ChangeTag from "common/Tags/ChangeTag";

interface LiveAvgPriceChange {
  symbol: string;
  initialChange: number;
  arrowStyle?: CSSProperties;
  initialChangeTimestamp?: number;
  /** Shows the change against this currency instead of the display currency. */
  currency?: DisplayCurrency;
  hideBackground?: boolean;
  style?: CSSProperties;
  textStyle?: CSSProperties;
}

const LiveAvgPriceChange = ({
  symbol,
  initialChange,
  arrowStyle,
  initialChangeTimestamp,
  currency,
  hideBackground,
  style,
  textStyle,
}: LiveAvgPriceChange) => {
  const { value, setChange } = useLiveAvgPriceChange({
    symbol,
    initialChange,
    initialChangeTimestamp,
  });

  return (
    <>
      {Object.values(EXCHANGES).map((exchange, index) => {
        return (
          <SocketPriceChangeComponent
            key={index}
            symbol={symbol}
            exchange={exchange}
            currency={currency}
            setChange={(change: number) => setChange(change, index)}
          />
        );
      })}
      <ChangeTag
        arrowStyle={arrowStyle}
        value={value}
        suffix="%"
        precisionType={PrecisionType.PERCENT}
        absoluteValue={true}
        hideBackground={hideBackground}
        style={style}
        textStyle={textStyle}
      />
    </>
  );
};

export default LiveAvgPriceChange;

interface SocketPriceChangeComponentProps {
  symbol: string;
  exchange: string;
  currency?: DisplayCurrency;
  setChange: (change: number) => void;
}

const SocketPriceChangeComponent = ({
  symbol,
  exchange,
  currency,
  setChange,
}: SocketPriceChangeComponentProps) => {
  const { change } = useGraphDataSocket(symbol, exchange, currency);

  useEffect(() => {
    if (change) setChange(change);
  }, [change]);

  return null;
};
